import { error } from '@sveltejs/kit';
import guides from '../guides.json';

export function entries() {
	return guides.map((guide) => ({ guide: guide.slug }));
}

export function load({ params }) {
	const guide = guides.find((item) => item.slug === params.guide);
	if (!guide) error(404, 'KdmGen guide not found');
	return { guide };
}
